export const AnalyticsTracking = {
  methods: {
    sendAnalyticsPageView: function (path, title) {
      var pageTitle = title || ''
      window.aspenwareDataLayer.push({
        event: 'VirtualPageview',
        // i.e. /cart/personalization
        virtualPageURL: path,
        // i.e. "Cart Personalization"
        virtualPageTitle: pageTitle,
      })
      if (pageTitle) {
        document.title = pageTitle
      }
    },
  },
}
